module.exports = __webpack_public_path__ + "img/three2Red.c6c3aec9.jpg";